import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { Link } from "react-router-dom";
import { handleGetAllChefs } from "../../services/get_without_auth";
import { shefDetailPath } from "../../shefPath";

const AllChef = () => {
  const [chefs, setChefs] = useState([]);
  //Chefs in a city
  useEffect(() => {
    (async () => {
      try {
        const city = JSON.parse(localStorage.getItem("region"));
        const response = await handleGetAllChefs(city.id);
        console.log("response of all-chef ", response);
        setChefs(response);
      } catch (error) {
        console.error(error);
      }
    })();
  }, []);
  return (
    <>
       <div>
      <Header />
      <div className="container mx-auto my-8 px-lg-2 px-4 relative">
        <div className="mt-8 relative z-10">
          <div className="relative inline-block">
            <h2 className="text-secondary font-bold text-2xl mb-0 pb-2 relative group">
              All Shefs
              <div className="absolute bottom-0 left-0 w-full h-0.5 bg-gradient-to-r from-red-500 to-red-600 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left"></div>
              <div className="absolute bottom-0 left-0 w-full h-px bg-gray-200"></div>
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-12 gap-4 mt-6 relative z-10">
          {/* Chefs */}
          {chefs?.map((item, index) => (
            <div
              key={item.id}
              className="lg:col-span-3 sm:col-span-6 col-span-12 bg-white rounded-lg shadow-lg border border-gray-200 group hover:shadow-xl hover:scale-105 transition-all duration-500 hover:-translate-y-1 relative overflow-hidden"
              style={{
                animationDelay: `${index * 100}ms`,
                borderTop: "3px solid #fce7f3", // Light pink initial top border
              }}
            >
              {/* Top border that changes on hover */}
              <div className="absolute top-0 left-0 w-full h-0.5 bg-red-700 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left"></div>

              <Link to={shefDetailPath(item.id, item.first_name, item.last_name)} className="flex flex-col justify-center py-6 px-4 relative z-10">
                <div className="flex items-center gap-x-3">
                  <div className="relative">
                    <img
                      src={item.profile_pic ? `${item.profile_pic}` : "./media/frontend/img/banner/chef-5.webp"}
                      className="img-fluid object-cover h-[80px] w-[80px] object-top rounded-full transition-all duration-300"
                      alt="Chef"
                    />
                  </div>

                  <div className="flex-1">
                    <h3 className="font-bold text-base leading-tight mb-1 group-hover:text-red-600 transition-colors duration-300">
                      {`${item.first_name || ""} ${item.last_name || ""}`}
                    </h3>
                    <p className="text-sm text-gray-500">Professional Shef</p>
                  </div>

                  {/* Simple arrow indicator */}
                  <div className="opacity-50 group-hover:opacity-100 group-hover:translate-x-1 transition-all duration-300">
                    <svg className="w-5 h-5 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </div>

        <style jsx>{`
          @keyframes slideInUp {
            from {
              opacity: 0;
              transform: translateY(30px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
          
          .grid > div {
            animation: slideInUp 0.6s ease-out forwards;
            opacity: 0;
          }
          
          .grid > div:nth-child(1) { animation-delay: 0ms; }
          .grid > div:nth-child(2) { animation-delay: 100ms; }
          .grid > div:nth-child(3) { animation-delay: 200ms; }
          .grid > div:nth-child(4) { animation-delay: 300ms; }
          .grid > div:nth-child(5) { animation-delay: 400ms; }
          .grid > div:nth-child(6) { animation-delay: 500ms; }
          .grid > div:nth-child(7) { animation-delay: 600ms; }
          .grid > div:nth-child(8) { animation-delay: 700ms; }
          .grid > div:nth-child(9) { animation-delay: 800ms; }
          .grid > div:nth-child(10) { animation-delay: 900ms; }
          .grid > div:nth-child(11) { animation-delay: 1000ms; }
          .grid > div:nth-child(12) { animation-delay: 1100ms; }
          
          /* Hover effect for top border */
          .group:hover {
            border-top-color: #b91c1c !important;
          }
        `}</style>
      </div>
      <Footer />
    </div>
    </>
  );
};

export default AllChef;
